import { z } from "zod";
import { getMultipleStoriesFromGlobalStoryblokStoriesByComponentType } from "../utils/global-story-functions";
import { useGlobalStoryblokStories } from "../utils/with-global-story";

const technicalFeatureSchema = z.object({
  heading: z.string(),
  icon: z
    .object({
      filename: z.string().optional(),
      alt: z.string().optional(),
    })
    .optional(),
  body: z.string().optional(),
});

export type TechnicalFeatureItem = z.infer<typeof technicalFeatureSchema>;

export const useTechnicalFeatures = (): TechnicalFeatureItem[] => {
  const globalStoryblokStories = useGlobalStoryblokStories();
  const stories = getMultipleStoriesFromGlobalStoryblokStoriesByComponentType(
    "TechnicalFeature",
    globalStoryblokStories,
  );

  return stories.flatMap((story) => {
    const parsed = technicalFeatureSchema.safeParse(story);
    return parsed.success ? [parsed.data] : [];
  });
};
